import script from "./TopPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./TopPagination.vue?vue&type=script&setup=true&lang=js"

import "./TopPagination.vue?vue&type=style&index=0&id=57c16c57&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57c16c57"]])

export default __exports__